@use "styles" as *;

$block: me-accordion-item;

.#{$block} {
  display: flex;
  outline: none;
  border-top: 1px solid;

  &--animated {
    .#{$block} {
      &__content {
        transition: max-height $transition-timing, opacity $transition-timing;
      }

      &__chevron {
        transition: opacity $transition-timing;
      }
    }
  }

  &__main {
    flex: 1;
  }

  &__content {
    max-height: 0;
    opacity: 1;
    overflow: hidden;
  }

  &__header {
    user-select: none;

    &[role=button] {
      cursor: pointer;
    }
  }

  &__icon {
    display: inline-grid;
    grid: "icon";
    cursor: pointer;
  }

  &__chevron {
    grid-area: icon;

    &--down {
      opacity: 0;
    }

    &--up {
      opacity: 1;
    }
  }

  &--collapsed {
    .#{$block}__content {
      opacity: 0;
    }

    .#{$block}__chevron {
      &--down {
        opacity: 1;
      }

      &--up {
        opacity: 0;
      }
    }
  }
}
